import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import { GetLanguage, IsEnglish } from '../../utils/language';
import i18next from 'i18next';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "@material-ui/core/TextField";
import { NumberFormatBase } from 'react-number-format';
import Button from 'react-bootstrap-button-loader';
import IconButton from '@material-ui/core/IconButton';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import AnnouncementSharpIcon from '@material-ui/icons/AnnouncementSharp';
import CloseIcon from '@material-ui/icons/Close';

import { getSurveyQuestion, saveSurvey } from '../../actions/survey';
import * as StatusCode from '../../scripts/StatusCode';
import * as StatusSurvey from '../../scripts/StatusSurveyCode'
import * as TypeInput from '../../scripts/TypeInput';
import AlertAlgo from '../controls/AlertSnack'
import styles from '../../styles/survey.module.css';
import { isEmpty, formatDate } from '../../utils';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles((theme) => ({
    divBody: {
        marginTop: '10px'
    },
    listItem: {
        display: 'table',
        paddingLeft: '0px',
        paddingRight: '0px'
    },
    labelQuestion: {
        top: 'unset !important',
        left: 'unset !important',
        position: 'unset !important',
        transform: 'unset !important'
    },
    formControl: {
        display: 'table !important'
    },
    genericInput: {
        marginBottom: '15px',
        width: '100%'
    },
    numericInput: {
        '& input': {
            textAlign: 'right'
        }
    },
    divButtons: {
        position: 'fixed',
        backgroundColor: '#ffffff',
        width: '100%',
        zIndex: '1',
        height: '50px',
        top: '140px',
        paddingTop: '10px',
        paddingBottom: '45px',
        paddingRight: '20px',
        '@media (max-width: 600px)': {
            top: '90px'
        }
    },
    buttonSubmit: {
        width: '100%'
    },
    headerDiv: {
        height: '60px',
        minWidth: '250px'
    },
    titleDirective: {
        float: 'left !important'
    },
    closeButton: {
        float: 'right',
        marginTop: '-9px'
    },
    divSection: {
        backgroundColor: 'var(--color2)',
        color: 'var(--color1)',
        paddingBottom: '0px',
        borderRadius: '10px',
        marginTop: '10px',
        'border': '1px solid var(--color1) !important',
        '& > .MuiListItemText-root': {
            marginTop: '0px !important'
        }
    },
    buttonDirect: {
        marginTop: '5px'
    },
    divContent: {
        marginTop: '55px'
    },
    dialog: {
        zIndex: '10000 !important'
    }
}));

export function SurveyQuestions(props) {
    const classes = useStyles();

    const [surveyId, setSurveyId] = React.useState(0);
    const [data, setData] = React.useState(null);
    const [disableSurvey, setDisableSurvey] = React.useState(true);
    const [dataInput, setDataInput] = React.useState(null);
    const [descriptionDirective, setDescriptionDirective] = React.useState('');
    const [openDirective, setOpenDirective] = React.useState(false);

    let indexInput = -1;
    let valueInputs = [];

    const alertRef = useRef(null);

    useEffect(() => {
    }, []);

    useEffect(() => {
        setSurveyId(props.surveyId);
    }, [props.surveyId]);

    useEffect(() => {
        if (surveyId > 0) {
            loadQuestions();
        }
    }, [surveyId]);

    useEffect(() => {
        if (props.status != null) {
            handleActivatePage();
        }
    }, [props.status]);

    useEffect(() => {
        if (data) {
            valueInputs = [];
            let index = 0;

            data.forEach(x => {
                x.form.forEach(y => {
                    const value = y.userValue ?? y.defaultValue;

                    valueInputs.push(
                        {
                            key: index,
                            value: value,
                            isRequired: y.isRequired,
                            typeInput: y.typeInput,
                            evaluationForm2Id: y.evaluationForm2Id
                        });
                    index++;
                });
            });

            setDataInput(valueInputs);
        }
    }, [data]);

    const loadQuestions = async () => {
        const response = await getSurveyQuestion(surveyId);

        if (response != null && response.status == StatusCode.STATUS_OK) {
            setData(response.result);
        } else {
            showMessageError(i18next.t('error:generic-error'));
        }
    }

    const handleActivatePage = () => {
        const status = props.status;
        setDisableSurvey(status !== StatusSurvey.IntStatus_Opened);
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const showMessageWarning = (message) => {
        alertRef.current.showMessageWarning(message);
    }

    const onChangeList = (event) => {
        handleDataInput(event.target.value, event.target.name);
    }

    const onChangeNumeric = (event, maxValue) => {
        let valueInput = parseInt(event.target.value);

        handleDataInput(valueInput, event.target.name);
    }

    const onChangeTxt = (event) => {
        handleDataInput(event.target.value, event.target.name);
    }

    //const onChangeDate = (event) => {
    //    handleDataInput(formatDate(event.target.value, 'date'), event.target.name);
    //}

    const handleDataInput = (value, name) => {
        const newState = dataInput.map(obj => {
            const index = parseInt(name.split('_')[1]);

            if (obj.key == index) {
                return { ...obj, value: value }
            }

            return obj;
        })

        setDataInput(newState);
    };

    const validateNumeric = (event, maxValue) => {
        let valueInput = parseInt(event.target.value);

        if (valueInput > maxValue) {
            valueInput = maxValue;

            // The onblur event make the alert message vanish, so I had to do the setTimeout to trick the problem
            setTimeout(() => {
                showMessageWarning(i18next.t('survey:question.message.maxLimit'));
            }, 100)
        }

        handleDataInput(valueInput, event.target.name);
    }

    const handleFocusNumeric = (event) => {
        // workaround to make it work in iOS
        event.target.setSelectionRange(0, event.target.value.length);
    }

    const AddInput = (typeInput, maxValue, list, isRequired) => {
        indexInput = indexInput + 1;

        const value = dataInput && dataInput.find(x => x.key == indexInput).value;

        switch (typeInput) {
            case TypeInput.Input_List:
                return (
                    <Select
                        labelId={`label_list_${indexInput}`}
                        id={`list_${indexInput}`}
                        name={`list_${indexInput}`}
                        value={value || ''}
                        onChange={onChangeList}
                        className={classes.genericInput + `${isRequired ? ' required' : ''}`}
                        disabled={disableSurvey}
                    >
                        {list && list.map((obj, index) =>
                            <MenuItem key={index} className={styles.selectItem} value={obj.id}>{`${IsEnglish() ? obj.labelEn : obj.labelFr}`}</MenuItem>
                        )}
                    </Select>
                )
                break;
            case TypeInput.Input_Numeric:
                return (
                    <NumberFormatBase
                        value={value || '0'}
                        id={`num_${indexInput}`}
                        name={`num_${indexInput}`}
                        onChange={(event) => onChangeNumeric(event, maxValue)}
                        className={classes.genericInput + ' ' + classes.numericInput + `${isRequired ? ' required' : ''}`}
                        onFocus={handleFocusNumeric}
                        onBlur={(event) => validateNumeric(event, maxValue)}
                        customInput={TextField}
                        disabled={disableSurvey}
                    />
                )
                break;
            case TypeInput.Input_Text:
                return (
                    <TextField
                        id={`txt_${indexInput}`}
                        name={`txt_${indexInput}`}
                        multiline
                        minRows={3}
                        className={classes.genericInput + `${isRequired ? ' required' : ''}`}
                        onChange={onChangeTxt}
                        value={value || ''}
                        disabled={disableSurvey}
                    />
                )
                break;
            case TypeInput.Input_Date:
                return (
                    //<MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment} locale={locale}>
                    //    <DatePicker
                    //        id={`dt_${indexInput}`}
                    //        name={`dt_${indexInput}`}
                    //        className={classes.genericInput + `${isRequired ? ' required' : ''}`}
                    //        value={value || null}
                    //        onChange={(event) => onChangeDate(event, `dt_${indexInput}`)}
                    //        format="yyyy-MM-DD"
                    //        cancelLabel={i18next.t('buttons:cancel')}
                    //        disabled={disableSurvey}
                    //    />
                    //</MuiPickersUtilsProvider>
                    /*<DatePicker value={value} onChange={onChangeDate} />*/
                    ""
                )
                break;
        }
    }

    const questions = (inputs) => {
        return (
            inputs && inputs.map((obj, index) => (
                <FormControl fullWidth key={index} className={classes.formControl}>
                    <List>
                        <ListItem>
                            <ListItemText primary={
                                <React.Fragment>
                                    <InputLabel className={`${classes.labelQuestion}${obj.isRequired ? ' required' : ''}`} id={`label-${index}`}>{IsEnglish() ? obj.labelInputEn : obj.labelInputFr}</InputLabel>
                                    {AddInput(obj.typeInput, obj.maxValue, obj.selectList, obj.isRequired)}
                                </React.Fragment>
                            } />
                            <ListItemSecondaryAction>
                                <IconButton edge="end" aria-label="edit" onClick={() => handleDirective(IsEnglish() ? obj.helpDescriptionEn : obj.helpDescriptionFr)}>
                                    <AnnouncementIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List>
                </FormControl>
            )))
    }

    const section = (
        <div>
            {data && data.map((obj, index) => (
                <React.Fragment key={index}>
                    <List>
                        <ListItem className={classes.divSection}>
                            <ListItemText primary={IsEnglish() ? obj.titleEn : obj.titleFr} />
                            <ListItemSecondaryAction>
                                <IconButton edge="end" className={classes.buttonDirect} aria-label="edit" onClick={() => handleDirective(IsEnglish() ? obj.helpDescriptionEn : obj.helpDescriptionFr)}>
                                    <AnnouncementSharpIcon style={{ color: 'var(--color1)'}} />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem className={classes.listItem}>
                            {questions(obj.form)}
                        </ListItem>
                    </List>
                    <Divider />
                </React.Fragment>
            ))}
        </div>
    );

    const handleSave = async () => {
        if (validateForm()) {
            const questions = [];

            dataInput.forEach(x => {
                questions.push({
                    evaluationForm2Id: x.evaluationForm2Id,
                    value: x.value.toString(),
                    valueType: x.typeInput
                });
            });

            const response = await saveSurvey(surveyId, questions);

            if (response == null || (response != null && response.status != StatusCode.STATUS_OK)) {
                // Error
                showMessageError(i18next.t('error:generic-error'));
            } else {
                handleLoadSurvey();
                showMessageSuccess(i18next.t('common:successMessage'));
            }
        }
    }

    const validateForm = () => {
        let isValid = true;

        dataInput.forEach(x => {
            if (x.isRequired) {
                if (isEmpty(x.value)) {
                    showMessageError(i18next.t('survey:question.message.requiredQuestions'));
                    isValid = isValid && false;
                }
            }
        });

        return isValid;
    }

    const handleDirective = (msg) => {
        setDescriptionDirective(msg);
        setOpenDirective(true);
    }

    const handleCloseDirective = () => {
        setOpenDirective(false);
    }

    const handleLoadSurvey = () => {
        props.handleLoadSurvey();
    }

    return (
        <div className={`${styles.rootPopBody} ${classes.divBody}`}>
            <div className={classes.divButtons}>
                <Button onClick={handleSave} variant="success" className={classes.buttonSubmit} disabled={disableSurvey}>
                    {i18next.t('buttons:submit')}
                </Button>
            </div>
            <div className={classes.divContent}>
                {section}
            </div>

            <Dialog
                open={openDirective}
                onClose={handleCloseDirective}
                className={classes.dialog}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title" className={classes.headerDiv}>
                    <div className={classes.titleDirective}>
                        Directive
                    </div>
                    <div className={classes.closeButton}>
                        <IconButton edge="end" aria-label="edit" onClick={handleCloseDirective} style={{ color: '#ffffff' }}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <span dangerouslySetInnerHTML={{ __html: descriptionDirective }} />
                    </DialogContentText>
                </DialogContent>
            </Dialog>

            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['common', 'survey', 'error'], { wait: true })(SurveyQuestions);